import { login, logout, me, menu, refresh } from './clients/authClient';
import { SecureStorage } from '@aparajita/capacitor-secure-storage';
export { AUTH_UNAUTHORIZED_EVENT } from './httpClient';

export const AUTH_STORAGE_KEY = 'cv.react.auth';
const AUTH_SECURE_STORAGE_KEY = 'session';
const AUTH_SECURE_STORAGE_PREFIX = 'coordinacion_visitas_auth_';
const AUTH_STORAGE_VERSION = 3;
let secureStorageReady = false;

async function ensureSecureStorageReady() {
    if (secureStorageReady) {
        return;
    }

    try {
        await SecureStorage.setKeyPrefix(AUTH_SECURE_STORAGE_PREFIX);
    } catch {
        // Si el plugin falla por plataforma, mantenemos fallback legacy.
    } finally {
        secureStorageReady = true;
    }
}

function readLegacyStoredAuth() {
    try {
        const raw = localStorage.getItem(AUTH_STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : null;
        if (!parsed) {
            return null;
        }

        if (parsed._version !== AUTH_STORAGE_VERSION) {
            localStorage.removeItem(AUTH_STORAGE_KEY);
            return null;
        }

        return parsed;
    } catch {
        return null;
    }
}

async function writeSecureStoredAuth(authData) {
    await ensureSecureStorageReady();
    await SecureStorage.set(AUTH_SECURE_STORAGE_KEY, {
        ...authData,
        _version: AUTH_STORAGE_VERSION,
    });
}

export async function loginRequest(credentials) {
    return login(credentials);
}

export async function meRequest(token) {
    return me(token);
}

export async function refreshRequest(token) {
    return refresh(token);
}

export async function logoutRequest(token) {
    await logout(token);
}

export async function menuRequest(token) {
    return menu(token);
}

export async function readStoredAuth() {
    await ensureSecureStorageReady();

    try {
        const parsed = await SecureStorage.get(AUTH_SECURE_STORAGE_KEY);

        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
            if (parsed._version === AUTH_STORAGE_VERSION) {
                return parsed;
            }

            await SecureStorage.remove(AUTH_SECURE_STORAGE_KEY);
            return null;
        }
    } catch {
        // Fallback legacy si secure storage no esta disponible.
    }

    const legacy = readLegacyStoredAuth();
    if (!legacy) {
        return null;
    }

    try {
        await writeSecureStoredAuth(legacy);
        localStorage.removeItem(AUTH_STORAGE_KEY);
    } catch {
        // Si falla la migracion, seguimos permitiendo lectura legacy.
    }

    return legacy;
}

export async function writeStoredAuth(authData) {
    await writeSecureStoredAuth(authData);
    try {
        localStorage.removeItem(AUTH_STORAGE_KEY);
    } catch {
        // No bloquear el flujo si no se puede limpiar legacy.
    }
}

export async function clearStoredAuth() {
    await ensureSecureStorageReady();

    try {
        await SecureStorage.remove(AUTH_SECURE_STORAGE_KEY);
    } catch {
        // Ignorar para no bloquear logout.
    }

    try {
        localStorage.removeItem(AUTH_STORAGE_KEY);
    } catch {
        // Ignorar para no bloquear logout.
    }
}
